import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../constants/common'
import { Divider as DividerComponent } from '../Divider'

import {
  SELECT_DROPDOWN_LIST_DIVIDER_OPTION_VALUE,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY,
} from './Select.constants'

export function filterSyncSelectOptionsByLabel(item, search) {
  return item.label.toLowerCase().includes(search.toLowerCase())
}

export function getSelectDropdownEntityListItenInfoStylesMods({
  className,
  disabled,
  isActive,
  isFocused,
  isHovered,
  styles,
}) {
  const mods = {
    [styles.disabled]: disabled,
    [styles.hover]: isActive || isFocused || isHovered,
  }

  return classNames(mods, className)
}

export function getSelectDropdownListFloatingConfig(
  maxHeight = SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY,
  minHeight
) {
  return {
    dropdownStyles: {
      maxHeight,
      minHeight,
    },
  }
}

export function getSelectDropdownListDividerOption({
  Divider = DividerComponent,
  index = 0,
} = EMPTY_OBJECT) {
  return {
    Divider,
    value: `${SELECT_DROPDOWN_LIST_DIVIDER_OPTION_VALUE}-${index}`,
  }
}
